<div class="send-sms-box">
  <i class="btn-close icon-edponline-Bop-071" (click)="dismissModal()"  aria-hidden="true"></i>
  <div class="d-flex flex-column h-100 align-items-center px-4 pt-5">
    <div class="mt-4 text-center">
      <h3 class="title-header">{{ 'pt.edp.edponline.sms_payments_send_data_by_sms' | translate }}</h3>
    </div>
    <div class="mt-3 text-center" *ngIf="!loading">
      <p class="info-text">{{ 'pt.edp.edponline.sms_payments_insert_telephone_number' | translate }}</p>
    </div>

    <edp-loader *ngIf="loading" [size]="'md'" [position]="'center'"></edp-loader>
    <form *ngIf="!loading" [formGroup]="form" (ngSubmit)="submit()">
      <div class="input-container fluid">
        <div class="d-flex flex-column h-100 mb-4">
          <label class="label-opcional mb-2">{{ 'pt.edp.edponline.telephone_number' | translate }}</label>
          <input class="input-phone" type="number" formControlName="phoneNumber"/>
          <span class="error input-error" [ngClass]="{ 'show': showPhoneError }">
            {{ 'pt.edp.edponline.mbway.input.error' | translate }}
          </span>
        </div>

        <div class="text-center">
          <button type="submit" class="btn btn-primary mt-3 px-5" [ngClass]="{ 'disabled': disableSubmit }">
            {{ 'pt.edp.edponline.form.submit'| translate | edpCapitalize }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
